export let WORKFLOWCONSTANTS = {
  params: {
    taskId: "taskId"
  },
  messages: {
    commonWorkflowErrorMessage: "Unable to retrive workflow details. Please try later..."
  }
}; 


// WEBPACK FOOTER //
// ./src/app/modules/workflow/workflow.constants.ts